import { Component,SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AgRendererComponent } from "@ag-grid-community/angular";

@Component({
  template : `<a href="javascript: void(0);"  (click)="onClick($event)" >{{params.data.user_email}}</a>`
 
})
export class DoclinkCellRenderer implements AgRendererComponent {    
  params: any;  
  url:any;  

  constructor(private readonly sanitizer: DomSanitizer){

  }

  agInit(params: any): void {

      this.params = params;
      const url = "mailto:"+params.data.user_email;
      this.url = this.sanitizer.sanitize(SecurityContext.URL,url);
  }

  refresh(params: any): boolean {
      return false;
  } 
  
  onClick(event:any){
    window.location.href = this.url;
  }
}